module.exports = __webpack_public_path__ + "static/media/LeftBackground.bab58e75.png";